"use client";

import { c as _c } from "react/compiler-runtime";
import { PreviewActionBar } from "@/components/studio/page-editor/PreviewActionBar";
import { NarrativeTextOrInput, NarrativeTextOrInputBody, NarrativeTextOrInputHeading } from "../NarrativeTextOrInput";
export function NarrativeText(t0) {
  const $ = _c(18);
  const {
    title,
    description,
    horizontalTextPosition,
    verticalTextPosition,
    className,
    titleClassName,
    descriptionClassName,
    textContainerClassName,
    variant,
    moduleIndex,
    isPreview: t1
  } = t0;
  const isPreview = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isPreview || $[1] !== moduleIndex) {
    t2 = isPreview && moduleIndex !== undefined && moduleIndex >= 0 ? <PreviewActionBar moduleIndex={moduleIndex} /> : null;
    $[0] = isPreview;
    $[1] = moduleIndex;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title || $[4] !== titleClassName) {
    t3 = <NarrativeTextOrInputHeading className={titleClassName} value={title} />;
    $[3] = title;
    $[4] = titleClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== description || $[7] !== descriptionClassName) {
    t4 = <div className="lg:max-h-[calc(800px-2*var(--overview-vertical-padding))] lg:overflow-auto"><NarrativeTextOrInputBody className={descriptionClassName} value={description} /></div>;
    $[6] = description;
    $[7] = descriptionClassName;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== className || $[10] !== horizontalTextPosition || $[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== textContainerClassName || $[15] !== variant || $[16] !== verticalTextPosition) {
    t5 = <NarrativeTextOrInput className={className} horizontalTextPosition={horizontalTextPosition} textContainerClassName={textContainerClassName} variant={variant} verticalTextPosition={verticalTextPosition}>{t2}{t3}{t4}</NarrativeTextOrInput>;
    $[9] = className;
    $[10] = horizontalTextPosition;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = textContainerClassName;
    $[15] = variant;
    $[16] = verticalTextPosition;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}